<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show" class="black--text">
    <vue-plotly :data="plotData" :layout="layout" :options="options" class="pa-0 ma-0" />
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
import VuePlotly from '@statnett/vue-plotly';
import {mapGetters} from 'vuex';
import {config} from '@/store/config';

export default {
  name: 'export_trends_1pmc',
  components: {
    VuePlotly,
  },
  props: [],
  computed: {
    ...mapGetters([
      'get_dsm_result',
      'historyPlotDataTotal',
      'getDsmAppState',
      'app_data',
      'single_product',
      'home_market_code',
    ]),

    plotData: function() {
      let plot_list = [];
      // let countries = this.countryNamesLink();
      let data = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results['top6_export_trends'];

      // console.log(data)data
      let top6_countries = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.top6.map(
        v => v['Supplying_Market'],
      );

      top6_countries.pop();
      top6_countries = top6_countries.reverse();

      const fill_colours = config.plot_top6_colors;
      let i = 0;
      for (const key of top6_countries) {
        if (key !== '-') {
          // console.log("==================================")
          // console.log(data[key]['Value'])
          // console.log("==================================")

          plot_list.push({
            y: this.array_value_conversion(data[key]['Value'], 'time_weighted'),
            x: data[key]['T_Year'],
            name: this.codeToMarket(key),
            stackgroup: 'one',
            fillcolor: fill_colours[6 - i],
            opacity: 0.5,
            line: {
              color: 'white',
              width: '0.5',
            },
          });
          i++;
        }
      }
      return plot_list;
    },
    show: function() {
      return (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
          .report_type_to_generate === '1PMC'
      );
    },
    layout: function() {
      return {
        title: {
          text:
            'Import trends from major competitors of ' +
            this.single_product +
            '  <br>supplying aggregated group of ' + this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations.markets_count+ ' target markets',
          font: {
            size: 10,
            color: 'black',
          },
          yref: 'container',
          x: 0.07,
          y: 0.94,
          yanchor: 'bottom',
          pad: {
            b: 10,
          },
        },

        height: '300',
        width: '350',
        autosize: true,
        margin: {
          l: 50,
          r: 0,
          b: 40,
          t: 60,
          pad: 2,
        },

        xaxis: {
          tickmode: 'linear',
          fixedrange: true,
          tickangle: -35,
          tickfont: {
            size: 10,
          },
        },
        yaxis: {
          title: '',
          rangemode: 'tozero',
          fixedrange: true,

          tickfont: {
            size: 10,
          },
            exponentformat:'none'
        },
        legend: {
          font: {size: 9},
          automargin: true,
        },
        annotations: [
          {
            x: '0.18',
            y: '1.05',
            xref: 'paper',
            yref: 'paper',
            xanchor: 'right',
            yanchor: 'bottom',
            text:
              this.app_data.value_mulitplier['prefix'] +
              ' ' +
              this.app_data.exchange_rate['Currency'].slice(0, 3),
            showarrow: false,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: -0.1,
            y: -0.14,
            xanchor: 'left',
            yanchor: 'top',
            text: config.CEPII_Source,
            showarrow: false,
            font: {
              family: 'Arial',
              size: 8.5,
              color: 'rgb(150,150,150)',
            },
          },
        ],
      };
    },
  },
  methods: {
  },
  data: function() {
    return {
      options: {
        responsive: true,
        displayModeBar: false,
      },
    };
  },
};
</script>
